import {ChoiceConfig, ChoiceModel} from 'models/configuration/ChoiceModel'
import {TrackKey, TrackModel} from 'models/configuration/TrackModel'
import {EventModel} from 'models/EventModel'
import {RegistrationModel} from 'models/registration/RegistrationModel'
import {UserModel} from 'models/UserModel'
import {WysiwygType} from 'types'
import {Memoize} from 'util/memoize'
import {PackKey, PackModel} from './PackModel'

export type OptionKey = string

export type OptionConfig = {
	key: OptionKey
	label: string
	description_above: WysiwygType
	subtitle: string
	events: Array<TrackKey>
	skipped_packages: Array<PackKey>
	choices: Array<ChoiceConfig>
	backend_only: boolean
}

export class OptionModel {
	event: EventModel
	config: OptionConfig

	constructor(event: EventModel, config: OptionConfig) {
		this.event = event
		this.config = config
	}

	@Memoize()
	get label(): OptionKey {
		return this.config.label
	}

	@Memoize()
	get descriptionAbove(): WysiwygType {
		return this.config.description_above
	}

	@Memoize()
	get subtitle(): OptionKey {
		return this.config.subtitle
	}

	@Memoize()
	get key(): OptionKey {
		return this.config.key
	}

	@Memoize()
	get skippedPackaged(): Array<PackModel> {
		const skippedPackKeys = new Set(this.config.skipped_packages)
		return this.event.packs.filter(pack => skippedPackKeys.has(pack.key))
	}

	@Memoize()
	get tracks(): Array<TrackModel> {
		const trackKeys = new Set(this.config.events)
		return this.event.tracks.filter(track => trackKeys.has(track.key))
	}

	@Memoize()
	get choices(): Array<ChoiceModel> {
		return this.config.choices.map(conf => new ChoiceModel(this, conf))
	}

	getChoiceFor(model: RegistrationModel | UserModel): ChoiceModel | undefined {
		const key = model.state.options[this.key]
		return this.choices.find(choice => choice.key === key)
	}
}
